module.exports = __webpack_public_path__ + "img/filter-icon.cb4f089.svg";